import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import {
  DialogHeader,
  DialogTitle,
  DialogBody
} from '@ps-design-system/components/Dialog';
import { Divider } from '@ps-design-system/components/Divider';

import PauseListing from './PauseListing';
import BlockTime from './BlockTime';

const PauseModalStepOne = ({ onNextStep, applyToAllListingsToggle, setApplyToAllListingsToggle }) => (
  <>
    <DialogHeader
      headerAlignment="left"
      showCloseButton
      className="pause-modal-step-one-container"
    >
      <DialogTitle className="pause-modal-dialog-header">
        <FormattedMessage id="pause.modal.step_one_title" defaultMessage="Pause your listing"/>
      </DialogTitle>
    </DialogHeader>
    <DialogBody>
      <div className="pause-step-one-body">
        <PauseListing onNextStep={onNextStep} applyToAllListingsToggle={applyToAllListingsToggle} setApplyToAllListingsToggle={setApplyToAllListingsToggle} />
        <Divider spacing={24} />
        <BlockTime/>
      </div>
    </DialogBody>
  </>
);
PauseModalStepOne.propTypes = {
  onNextStep: PropTypes.func,
  applyToAllListingsToggle: PropTypes.bool,
  setApplyToAllListingsToggle: PropTypes.func
};

PauseModalStepOne.defaultProps = {
  onNextStep: () => {},
  applyToAllListingsToggle: false,
  setApplyToAllListingsToggle: () => {}
};

export default PauseModalStepOne;
